// extracted by mini-css-extract-plugin
export var dataCell = "_qr-2";
export var dataRow = "_qr-0";
export var headerRow = "_qr-1";